import { JSONSchema7 } from 'json-schema';
import JSONSchema7Properties from '../../../Shared/jSONSchema7Properties';

export default (currVer: JSONSchema7): JSONSchema7 => {
  const properties = currVer.properties as JSONSchema7Properties;

  properties['version'].default = 3;
  properties['styling'].default = 'none';
  properties['label'].default = '';

  return {
    ...currVer,
    properties
  };
};
